// These three constants are needed for the description meta tags

export const DISCLAIMER_EFFECTIVE_DATES = {
  US: 'April 24, 2026',
  US_MASTER_REWARDS: 'June 30, 2026',
  CA: 'July 31, 2025',
};

export const PRIVACY_EFFECTIVE_DATES = {
  US: 'November 25, 2024',
  CA: 'July 31, 2025',
};

export const TERMS_EFFECTIVE_DATE = {
  CONTEST: 'January 24, 2022',
  RECEIPT: 'September 1, 2024',
};
